module.exports = __webpack_public_path__ + "img/mid.487f419f.png";